module.exports = __webpack_public_path__ + "img/fernando2.3217bd37.jpg";